<template>
	<div class="editor">
		<div class="width-100">
			<StepDetailsHeader icon="notification-bell" :serviceId="editNode.service" :showDropdownMenu="false" v-on="$listeners" />
		</div>
		<NotificationEditorBody :hasEditPermissions="hasEditPermissions" />
	</div>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import { editNode, notification } from '@/store/modules/selectedNode/getters';
import StepDetailsHeader from '@/components/BlockEditor/StepDetailsHeader.vue';
import NotificationEditorBody from '@/components/BlockEditorNotification/NotificationEditorBody.vue';

export default {
	name: 'NotificationEditor',
	props: {
		hasEditPermissions: { type: Boolean },
	},
	components: {
		StepDetailsHeader,
		NotificationEditorBody,
	},
	computed: {
		...mapGettersShorthand({ editNode, notification }),
	},
};
</script>

<style scoped lang="scss">
$top-bar-height: 69px;
$bottom-bar-height: 65px;

.editor {
	height: calc(100% - #{$bottom-bar-height} - 5px);
}
::v-deep {
	.input-and-action-container .b_name_input {
		font-size: 18px;
		font-weight: 600;
		color: #292829;
		letter-spacing: 0px;
	}
}
</style>
